/* eslint-disable implicit-arrow-linebreak */
/* eslint-disable max-len */
/* eslint-disable no-console */
/* eslint-disable @typescript-eslint/naming-convention */
/* eslint-disable no-underscore-dangle */
/* eslint-disable no-void */
/* eslint-disable consistent-return */
/* eslint-disable no-case-declarations */
/* eslint-disable import/order */
/* eslint-disable arrow-body-style */
import React from "react";

import { NavigateFunction, useNavigate, useSearchParams } from "react-router-dom";

import { TRAINING_TYPE_CAREER, TRAINING_TYPE_CURRICULUM } from "../../Constants";

import Login from "./Login";

import SearchCareerClassListService, { SearchCareerClassListResponse, CareerResultsItem } from "../../logic/api/SearchCareerClassListService";
import { showErrorMessage } from "../../logic/hook/useDialogStateHelper";

const searchCareerClassListService = new SearchCareerClassListService();

const navigateTo = (path: string, navigator: NavigateFunction) => navigator(path);

const validateCareer = async (careerId: string | null, navigator: NavigateFunction): Promise<boolean> => {
    // エラーハンドリング：エラーメッセージを表示、OKボタンのクリック時はログイン画面を表示
    const handleError = (message: string) => {
        showErrorMessage({
            message,
            resolve: () => navigateTo("/", navigator),
        });
    };

    // 全件検索(eラーニング・集合研修)
    let valid: boolean = true;
    await searchCareerClassListService.searchCareerClassList(
        {
            careerType: TRAINING_TYPE_CAREER,
            elearning: true,
            shugo: true,
            tuusin: false,
        },
        (response: SearchCareerClassListResponse) => {
            // 検索結果に研修IDが一致する研修(クラス)があるか：表示・申込期間、表示対象組織についてはAPI側で加味
            const exists = (response.careerResults || []).some((career: CareerResultsItem) => career.careerId === careerId);

            // あればチェック終了⇒講座詳細表示
            if (exists) return;

            // 無ければエラー表示
            handleError("表示できない講座です。");
            valid = false;
        },
        (error: unknown) => {
            // APIレベルのエラー
            console.error(error);
            handleError("講座情報の取得に失敗しました。");
            valid = false;
        }
    );
    return valid;
};

const validateCurriculum = async (careerId: string | null, navigator: NavigateFunction): Promise<boolean> => {
    // エラーハンドリング：エラーメッセージを表示、OKボタンのクリック時はログイン画面を表示
    const handleError = (message: string) => {
        showErrorMessage({
            message,
            resolve: () => navigateTo("/", navigator),
        });
    };

    // 全件検索(カリキュラム)
    let valid: boolean = true;
    await searchCareerClassListService.searchCareerClassList(
        { careerType: TRAINING_TYPE_CURRICULUM },
        (response: SearchCareerClassListResponse) => {
            // 検索結果にカリキュラムIDが一致するカリキュラムがあるか：表示期間、表示対象組織についてはAPI側で加味
            const exists = (response.careerResults || []).some((career: CareerResultsItem) => career.careerId === careerId);

            // あればチェック終了⇒カリキュラム詳細表示
            if (exists) return;

            // 無ければエラー表示
            handleError("表示できないカリキュラムです。");
            valid = false;
        },
        (error: unknown) => {
            // APIレベルのエラー
            console.error(error);
            handleError("カリキュラム情報の取得に失敗しました。");
            valid = false;
        }
    );
    return valid;
};

const DirectLogin = () => {
    const [searchParams] = useSearchParams();
    const location = searchParams.get("location");
    const careerId = searchParams.get("careerId");

    const navigate = useNavigate();

    let navigateUrl;
    let preNavigate;
    switch (location) {
        case "trainingDetail":
            navigateUrl = `/training/detail/${careerId}`;
            preNavigate = async () => {
                const valid = await validateCareer(careerId, navigate);
                return valid;
            };
            break;
        case "curriculumDetail":
            navigateUrl = `/curriculum/detail/${careerId}`;
            preNavigate = async () => {
                const valid = await validateCurriculum(careerId, navigate);
                return valid;
            };
            break;
        default:
            break;
    }
    if (!navigateUrl) return <></>;
    return <Login {...{ navigateUrl, preNavigate }} />;
};

export default DirectLogin;
